import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> =  [
  {
    path: '/seo',
    component: () => import('@/views/SEO/Index.vue'),
    meta: {
      requiresAuth: true,
    }
  },
]

export default routes;